
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action, State } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import SureViewIcon from "@/components/SureViewIcon.vue"

import { IntegrationLog, IntegrationService, IntegrationSettings, IntegrationStatus, IntegrationSummary, MessageType, ServiceStatus } from "@/types/integration"

import api from "@/services/api"
import integrationApi from "@/services/api_Integrations"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"sv-icon": SureViewIcon
	}
})
export default class IntegrationView extends Vue {
	@State integrations!: IntegrationSummary[]

	@Prop()
	integration!: IntegrationSummary

	logColumns = [
		{
			key: "occurred"
		},
		{
			key: "environmentName",
			label: "Environment"
		},
		{
			key: "messageType"
		},
		{
			key: "message"
		},
		{
			key: "caseNumber",
			label: "Record"
		}
	]

	services: IntegrationService[] = []
	logMessages: IntegrationLog[] = []

	logsOldestDate: Date | null = null
	logsMoreAvailable: boolean = false
	loadingLogs: boolean = false

	status: IntegrationStatus | null = null
	loadingStatus: boolean = false

	async mounted () {
		if (this.integration) {
			integrationApi.integrationServicesGet(this.integration.integrationKey).then(services => this.services = services)
			this.loadLogs()

			if (this.integration.allowForceRun) {
				this.statusGet()
			}
		}
	}

	serviceClass (status: ServiceStatus | null) {
		if (status == null) {
			return "text-muted"
		}

		switch (status) {
			case ServiceStatus.Ok: return "text-success"
			case ServiceStatus.Warning: return "text-warning"
			case ServiceStatus.Error: return "text-danger"
			case ServiceStatus.Offline: return "text-muted"
		}
	}

	messageType (type: MessageType) {
		switch (type) {
			case MessageType.Error: return "Error"
			case MessageType.Warning: return "Warning"
			case MessageType.Information: return "Information"
		}
		return type
	}

	async loadLogs () {
		this.loadingLogs = true
		integrationApi.logGet(this.integration.integrationKey, this.logsOldestDate).then(logs => {
			this.logMessages.push(...logs)

			if (logs.length > 0) {
				this.logsOldestDate = logs[logs.length - 1].occurred
			}
			this.logsMoreAvailable = logs.length === 100
			this.loadingLogs = false
		})
	}

	async statusGet () {
		this.loadingStatus = true

		try {
			this.status = await integrationApi.statusGet(this.integration.integrationKey)
		} finally {
			this.loadingStatus = false
		}
	}

	async forceRun () {
		await integrationApi.forceRun(this.integration.integrationKey)
		this.statusGet()
	}

	public openRecord (caseNumber: string, newTab: boolean = false) {
		const encodedCaseNumber = encodeURIComponent(caseNumber)
		if (newTab) {
			const routeData = this.$router.resolve({ path: `/cases/${encodedCaseNumber}` })
			window.open(routeData.href, "_blank")
		} else {
			this.$router.push({ path: `/cases/${encodedCaseNumber}` })
		}
	}
}

